import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import { SplitButton } from '../../../common/SplitButton'
import { connect } from 'react-redux'
import * as URL from '../oldReportsUrls'
import { useDispatch, useSelector } from 'react-redux'
import * as id from '../reportId'
import Datepicker from '../../../common/datePicker'
import {
  getLRPenaltyReportFilterData,
  getOwnBookingFilterData,
} from '../../../../store/reports/reports_action'
import moment from 'moment'

import { RefreshSvg } from '../../../common/svg/refresh'
import { appendToUrl, focusElemnt, getInt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { headerColumnToPayDestinationReport } from '../common/reportConstants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../common/loginDecode'

const ToPayDestinationReport = (props) => {
  const {
    data: { common, reports },
    updateAlertError,
  } = props

  const state = useSelector((state) => state)
  const { ownBookingDropData } = reports
  const dispatch = useDispatch()
  const [disableBtn, setDisableBtn] = useState(false)
  const { ownChildBranches } = reports
  const [sourceBranchData, setSourceBranchData] = useState(ownChildBranches)
  const [sourceCity, setSourceCity] = useState([])
  const [sourceBranch, setSourceBranch] = useState([])
  const [sourceCityData, setSourceCityData] = useState([])
  const [sourceBranchUser, setSourceBranchUser] = useState('')
  const [sourceBranchUserData, setSourceBranchUserData] = useState([])
  const [destinationCity, setDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [destinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchdata, setSelDestinationBranchdata] = useState([])
  const [toDate, setToDate] = useState(moment(new Date()))
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const reportName = 'To Pay Destination'

  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }  
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = searchParams.get('AllowViewAllBranchReport') || 0
    AllowBranchInchargeRights = searchParams.get('AllowBranchInchargeRights') || 0
    isFromUrl = true
  }
  const { intCompanyID, IsAdmin, intUserID, intBranchID, intBranchCityID, strCompanyName, IsBranchAdmin, strBranchName, strCityName, strUserName, IsMTPLAdmin } = loginData

  const criteriaHeaders = [
    { field: 'company', header: 'Company', textAlign: 'left' },
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Date', textAlign: 'left' },
    { field: 'sourceCity', header: 'Sourch City', textAlign: 'left' },
    { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
    { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
  ]
  const criteriaData = {
    company: strCompanyName,
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    sourceCity: sourceCity?.SourceCityName,
    sourceBranch: sourceBranch?.SourceBranchName,
    destinationCity: destinationCity?.DestCityName,
    destinationBranch: destinationBranch?.DestBranchName,
    dataType: 'entry',
  }

  const filterData = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: intCompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
        FranchCompID: 0,
      }
      dispatch(getOwnBookingFilterData(obj))
    }
  }

  const selectedSourceBranch = (obj) => {
    setSourceBranch(obj)
  }

  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSourceCity(' ')
    setSourceBranch(' ')
    setSourceBranchUser(' ')
    setDestinationCity(' ')
    setSelDestinationBranch(' ')
  }

  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (!isEmpty(roleRightsData) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          AllowViewAllBranchReport == 1 ||
          AllowBranchInchargeRights == 1 ||
          IsBranchAdmin ||
          IsMTPLAdmin ||
          IsAdmin
        )
      )
    }
  }, [roleRightsData, loginData])
  useEffect(() => {
    if (ownBookingDropData.status === 'Success') {
      if (ownBookingDropData?.Data?.Table?.length >= 1) {
        const SourceCity = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({ SourceCityName: val.SourceCityName, SourceCityID: val.SourceCityID }))
          ),
        ]
        const SourceBranch = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              SourceBranchName: val.SourceBranchName,
              SourceBranchID: val.SourceBranchID,
              SourceCityID: val.SourceCityID,
            }))
          ),
        ]
        const SourceBranchUser = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              UserBooked: val.UserBooked,
              UserID: val.UserID,
              SourceBranchID: val.SourceBranchID,
            }))
          ),
        ]
        const DestinationCity = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              DestCityName: val.DestCityName,
              DestCityID: val.DestCityID,
              SourceCityID: val.SourceCityID,
            }))
          ),
        ]
        const DestinationBranch = [
          ...new Set(
            ownBookingDropData?.Data?.Table?.map((val) => ({
              DestBranchName: val.DestBranchName,
              DestBranchID: val.DestBranchID,
              DestCityID: val.DestCityID,
            }))
          ),
        ]
        if (disableBtn) {
          setSourceCity({ SourceCityName: strCityName, SourceCityID: intBranchCityID })
          if (disableBtn && AllowViewAllBranchOfCityReport == 1) {
            const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === intBranchID)
            const selectedUser = SourceBranchUser?.filter((val) => val.UserID === intUserID)
            if (selectedBranch?.length > 0) {
              setSourceBranch(selectedBranch?.[0])
            } else {
              setSourceBranch({ SourceBranchName: 'All Branch', SourceBranchID: 0 })
            }
            if (selectedUser?.length > 0) {
              setSourceBranchUser(selectedUser?.[0])
            } else {
              setSourceBranchUser({ UserBooked: 'All Branch User', UserID: 0 })
            }
          } else {
            setSourceBranch({ SourceBranchName: strBranchName, SourceBranchID: intBranchID })
            setSourceBranchUser({ UserBooked: strUserName, UserID: intUserID })
          }
        } else {
          const selectedCity = SourceCity?.filter((val) => val.SourceCityID === intBranchCityID)
          const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === intBranchID)
          const selectedUser = SourceBranchUser?.filter((val) => val.UserID === intUserID)
          if (selectedCity?.length > 0) {
            setSourceCity(selectedCity?.[0])
          } else {
            setSourceCity({ SourceCityName: 'All Cities', SourceCityID: 0 })
          }
          if (selectedBranch?.length > 0) {
            setSourceBranch(selectedBranch?.[0])
          } else {
            setSourceBranch({ SourceBranchName: 'All Branch', SourceBranchID: 0 })
          }
          if (selectedUser?.length > 0) {
            setSourceBranchUser(selectedUser?.[0])
          } else {
            setSourceBranchUser({ UserBooked: 'All Branch User', UserID: 0 })
          }
        }
        setSourceCityData([{ SourceCityName: 'All Cities', SourceCityID: 0 }, ...SourceCity])
        setSourceBranchData([{ SourceBranchName: 'All Branch', SourceBranchID: 0 }, ...SourceBranch])
        setSourceBranchUserData([{ UserBooked: 'All Branch User', UserID: 0 }, ...SourceBranchUser])
        setDestinationCityData([{ DestCityName: 'All Cities', DestCityID: 0 }, ...DestinationCity])
        setSelDestinationBranchdata([{ DestBranchName: 'All Branch', DestBranchID: 0 }, ...DestinationBranch])
        setDestinationCity({ DestCityName: 'All Cities', DestCityID: 0 })
        setSelDestinationBranch({ DestBranchName: 'All Branch', DestBranchID: 0 })
      } else {
        setSourceCityData([])
      }
    }
  }, [ownBookingDropData])
  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  const generateReport = (isPdf = false) => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = sourceCity?.SourceCityID === 0 || sourceBranch?.SourceBranchID === 0 || destinationCity?.DestCityID === 0 || destinationBranch?.DestBranchID === 0;

    if (sourceCity == '' || sourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    } else if (sourceBranch == '' || sourceBranch == ' ') {
      updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    } else if (isAllSelected && diffDays > 15) {
      updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' });
    } else if (!isAllSelected && diffDays > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' });
    } else {
      const body = {
        CompanyID: intCompanyID,
        BranchID: sourceBranch?.SourceBranchID || 0,
        DestinationCityID: destinationCity?.DestCityID || 0,
        dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(toDate).format('YYYY-MM-DD'),
        UserID: intUserID,
        AllowViewAllReport: 1,
        SourceCityID: sourceCity?.SourceCityID || 0,
        SourceBranchID: sourceBranch?.SourceBranchID || 0,
        DestinationBranchID: destinationBranch?.DestBranchID || 0
      }
      setLoader(true)
      GetRequest(urls.getToPayDestinationReportData, body)
        .then((res) => {
          setLoader(false)
          if (res.status !== 'Success') {
            throw new Error(res?.ErrMessage || 'Invalid Response')
          }
          if (!res.Data.Table.length) {
            setAlert({ show: true, msg: 'No Data Found!', nextId: '' })
            return
          }
          let tableData = res.Data?.Table.map((item, index) => ({
            ...item,
            SN: index + 1,
            dataType: 'entry'
          }))

          let totalNOPS = tableData.reduce((sum, item) => sum + (item.NOPS || 0), 0);
          let totalAmount = tableData.reduce((sum, item) => sum + (item.Total || 0), 0);
          tableData.push({
            SN: '',
            VEHICLE: 'Total',
            NOPS: totalNOPS,
            Total: totalAmount,
            dataType: 'total'
          });
          let headers = headerColumnToPayDestinationReport.map((a) => ({
            ...a,
            field: a.field,
            align: a.xlCol.dataType === "quantity" ? "right" : "left",
            width: getInt(a.minWidth),
            weight: 80
          }))
          let reportPayload = {
            reportName: 'To Pay Destination Report',
            criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: tableData,
            mainHeader: headers,
            serialNokey: 'SN',
          }
          if (isPdf === true) {
            downloadPDF({
              reportName: 'To Pay Destination Report',
              criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: tableData,
              visibleColumns: headers,
              loginData,
              hideHeader: false
            })
            return
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        })
        .catch((error) => {
          setAlert({ show: true, msg: error.message, nextId: '' })
        })
    }
  }



  const handleClick2 = () => {
    if (sourceCity == '' || sourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    } else if (sourceBranch == '' || sourceBranch == ' ') {
      updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    } else {
      let url = URL.toPayDestinationReport
      const urlData = URL.toPayDestinationReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.intBranchID = sourceBranch?.SourceBranchID || 0
      urlData.intDestinationCityID = destinationCity?.DestCityID || 0
      urlData.fromdate = moment(fromDate).format('YYYY-MM-DD')
      urlData.todate = moment(toDate).format('YYYY-MM-DD')
      urlData.AllowViewAllReport = 1
      urlData.intAllowExportToExcel = 1
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  const selectedSourceCity = (obj) => {
    setSourceCity(obj)
    setSourceBranch(
      removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID').filter(
        (val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0
      )?.[0]
    )
  }
  const selectedDestCity = (obj) => {
    setDestinationCity(obj)
    setSelDestinationBranch(
      removeDuplicatesFromArray(destinationBranchdata, 'DestBranchID').filter(
        (val) => val.DestCityID === obj?.DestCityID || obj?.DestCityID === 0 || val.DestBranchID === 0
      )?.[0]
    )
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && <><Item sx={sx.itemsx}>
            <DropDownOA label={'Select Company'} defaultvalue={strCompanyName} disabled={true} width="240px" />{' '}
          </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                GO
              </Button>
            </Item>
          </>}
          <Item sx={sx.itemsxGrow} style={{ width: !isFromUrl ? '100px' : 'auto' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
            <Item sx={sx.itemsxGrow} style={{ width: !isFromUrl ? '181px' : 'auto' }} className="input--container bookingDatePicker">
              <Datepicker
                label={'To Date'}
                value={toDate}
                id={id.toDate}
                dateChange={(date) => {
                  setToDate(date)
                  focusElemnt('goodGoBtn')
                }}
                width="100%"
                dateDiff={730}
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                id="goodGoBtn"
                onKeyDown={(e) => navigation3(e, 'sourceCity', id.toDate, () => filterData())}
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                className="btn btn-primary"
                onClick={filterData}
              >
                GO
              </Button>
            </Item>
          </Box>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              label="Source City"
              id="sourceCity"
              nextId={'sourceBranch'}
              prevId={'goodGoBtn'}
              data={removeDuplicatesFromArray(sourceCityData, 'SourceCityID') || []}
              defaultvalue={sourceCity?.SourceCityName || sourceCity}
              dataKey={`SourceCityName`}
              idKey={`SourceCityID`}
              disabled={disableBtn}
              onSelect={(obj) => selectedSourceCity(obj)}
              width={isFromUrl ? '100%' : '170px'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              label="Source Branch"
              id="sourceBranch"
              nextId={'destinationCity'}
              prevId={'sourceCity'}
              disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}              
              data={
                removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID').filter(
                  (val) => val.SourceCityID === sourceCity?.SourceCityID || sourceCity?.SourceCityID === 0 || val.SourceBranchID === 0
                ) || []
              }
              defaultvalue={sourceBranch?.SourceBranchName || sourceBranch}
              dataKey={`SourceBranchName`}
              idKey={`SourceBranchID`}
              onSelect={(val) => selectedSourceBranch(val)}
              width={isFromUrl ? '100%' : '170px'}
              listWidth={'250px'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              label="Destination City"
              id="destinationCity"
              nextId={'destinationBranch'}
              prevId={'sourceBranch'}
              defaultvalue={destinationCity?.DestCityName || destinationCity}
              data={
                removeDuplicatesFromArray(destinationCityData, 'DestCityID').filter(
                  (val) => val.DestCityID !== sourceCity?.SourceCityID || val.DestCityID === 0
                ) || []
              }
              dataKey={`DestCityName`}
              idKey={`DestCityID`}
              onSelect={(obj) => selectedDestCity(obj)}
              width={isFromUrl ? '100%' : '170px'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              label="Destination Branch"
              id="destinationBranch"
              nextId={'generateButton'}
              prevId={'destinationCity'}
              defaultvalue={destinationBranch?.DestBranchName || destinationBranch}
              data={
                removeDuplicatesFromArray(destinationBranchdata, 'DestBranchID').filter(
                  (val) => val.DestCityID === destinationCity?.DestCityID || destinationCity?.DestCityID === 0 || val.DestBranchID === 0
                ) || []
              }
              dataKey={`DestBranchName`}
              idKey={`DestBranchID`}
              onSelect={(obj) => {
                setSelDestinationBranch(obj)
              }}
              width={isFromUrl ? '100%' : '170px'}
              listWidth={'180px'}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => generateReport(true)} id1={'generateButton'}>
              DOWNLOAD PDF
            </Button> :
            <>
              <Item
                sx={sx.itemsx}
                onKeyDown={(e) => {
                  navigation3(e, 'fromDate', 'destinationBranch', () => generateReport())
                }}
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  id1={'generateButton'}
                  onClick1={generateReport}
                  onClick2={handleClick2}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                <RefreshSvg width={'24px'} height={'24px'} />
              </Item>
            </>}
        </Box>
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getLRPenaltyReportFilterData,
  updateAlertError,
}
export default connect(mapStateToProps, mapDispatchToProps)(ToPayDestinationReport)
